<ul>
  <li>
    <p>
      <span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >The doughnut charts show the degree of the achievement of targets. If YTD is selected as timeframe, it shows the target
              achievement for YTD compared to the target for YTD (= all past months of the current year including the current month). If a
              previous year is selected as timeframe, it shows the target achievement in December of the selected year compared to the
              target for the whole selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >: The icon indicates, whether the target regarding the number of new leads, new opportunities, new customers and sold boluses
              is met (</span
            ></span
          ></span
        ><span style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span><span lang="en-GB">) or missed (</span></span></span
        ><span style="color: #ffc000;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span><span lang="en-GB">).</span></span></span
        ></span
      >
    </p>
  </li>
</ul>
<p lang="en-GB">&nbsp;</p>
<p><span><span style="color: #404040;"><span><span lang="en-GB">List:</span></span></span></span></p>
<p>
  <span style="color: #51c3f9;">■</span><span
    ><span style="color: #404040;"><span><span lang="en-GB">New LEADS </span></span></span><span style="color: #404040;"
      ><span><span lang="en-GB"><strong>86%</strong></span></span></span
    ><span style="color: #404040;"><span><span lang="en-GB">7,9k</span></span></span><span style="color: #bfbfbf;"
      ><span><span lang="en-GB">[PY: 4,2k] </span></span></span
    ><span style="color: #404040;"><span><span lang="en-GB">| </span></span></span><span style="color: #00b0f0;"
      ><span><span lang="en-GB">Target: 9,2k</span></span></span
    ></span
  >
</p>
<p lang="en-GB">&nbsp;</p>
<p>
  <span
    ><span style="color: #404040;"><span><span lang="en-GB"><strong>86%</strong></span></span></span><span style="color: #404040;"
      ><span><span lang="en-GB"> &hellip; 86% of the target has been achieved YTD or at the end of the selected year</span></span></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"><span><span lang="en-GB">7,9k</span></span></span><span style="color: #404040;"
      ><span
        ><span lang="en-GB">
          &hellip; Actual number of new leads / new opportunities / new customers / sold boluses YTD or at the end of the selected year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #bfbfbf;"><span><span lang="en-GB">[PY: 4,2k] </span></span></span><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          >&hellip; Number of new leads / new opportunities / new customers / sold boluses in the same period YTD of the previous year or at
          the end of the previous year</span
        ></span
      ></span
    ></span
  >
</p>
<p style="margin-bottom:10px;">
  <span
    ><span style="color: #00b0f0;"><span><span lang="en-GB">Target: 9,2k </span></span></span><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          >&hellip; Target for new leads / new opportunities / new customers / sold boluses for YTD or for the whole selected year</span
        ></span
      ></span
    ></span
  >
</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }

  img {
    width: 11px;
    height: 2px;
  }
</style>
